export const irisPro =
	'https://storage.googleapis.com/gcp-frontend-widget-av-iris-eu-pro/load-iris.js'
export const irisTest =
	'https://storage.googleapis.com/gcp-frontend-widget-av-iris-eu-pre/load-iris.js'
